/**
 * @voltxampere/ui — ATmega328P (Arduino UNO) variant (Sprint 47-1)
 *
 * Sprint 43-5'te `digital-gate` placeholder shipped (gateFunction:"NOT").
 * Sprint 47-1 ile mcu-execution canonical engine type'a migrate
 * edildi (Sprint 46 ADR-0067 + ADR-0068 emulator infrastructure
 * üzerine). Sprint 47-2'de stamp body no-op'tan gerçek emulator
 * call'una aktive edilir.
 *
 * Reference: Microchip ATmega328P-PU, DIP-28. AVR-8bit family.
 * Vcc 1.8-5.5 V, fmax 20 MHz, 32 KB Flash / 2 KB SRAM / 1 KB EEPROM,
 * 23 GPIO, 8-channel 10-bit ADC, 6 PWM, 1 UART / 1 SPI / 1 I2C.
 *
 * Sprint 46 component definition (`mcu-execution`) per-family
 * defaults (flashSize/ramSize/gpioPinCount/adcPinCount/pwmPinCount)
 * `family` field'ından otomatik resolve eder; bu variant sadece
 * `family: "atmega328p"` + `clockHz: 16e6` set eder.
 *
 * Engine zero-diff cumulative invariant Sprint 46 baseline
 * (`227f99d`)'den korunur; mcu-execution canonical type Sprint 46-3'te
 * eklendi, ADR-0066 dersi tutuldu (SchemaType union same-sprint).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuAtmega328p = {
    id: "atmega328p",
    nameTr: "ATmega328P (Arduino UNO, DIP-28)",
    nameEn: "ATmega328P (Arduino UNO, DIP-28)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "ATmega328P",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega328p",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-atmega328p.js.map